import React from 'react';
import { Users } from 'lucide-react';

type Props = {
  count: number;
};

export const PilgrimCountBadge = ({ count }: Props) => {
  const getColors = () => {
    if (count > 50) return 'bg-red-50 text-red-700';
    if (count > 20) return 'bg-yellow-50 text-yellow-700';
    return 'bg-green-50 text-green-700';
  };

  return (
    <span className={`inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full text-sm font-medium ${getColors()}`}>
      <Users size={14} />
      {count}
    </span>
  );
};